import type { ClipboardEvent } from "react";

export const payerTextPattern = /^[^<>]*(?![\s\S])/;
export const payerTextMessage = "Angle brackets (< and >) are not allowed.";

export function hasPayerAngleBrackets(value: string): boolean {
    return /[<>]/.test(value);
}

export function normalizePayerFreeText(value: string, previousValue = "", maxLength?: number): string {
    if (!hasPayerAngleBrackets(value)) {
        return maxLength === undefined ? value : value.slice(0, maxLength);
    }
    // Permit deletion from historical invalid text so users can correct it.
    if (value.length < previousValue.length) {
        let index = 0;
        for (let i = 0; i < previousValue.length; i++) {
            if (previousValue[i] === value[index]) index++;
        }
        if (index === value.length) return value;
    }
    return previousValue;
}

export function preventUnsafePayerPaste(event: ClipboardEvent<HTMLElement>, onRejected: () => void): void {
    if (hasPayerAngleBrackets(event.clipboardData.getData("text"))) {
        event.preventDefault();
        onRejected();
    }
}
